import { render } from "./ClusterLegendItem.vue?vue&type=template&id=1953cf0d"
import script from "./ClusterLegendItem.vue?vue&type=script&lang=ts"
export * from "./ClusterLegendItem.vue?vue&type=script&lang=ts"
script.render = render

export default script